module.exports = __webpack_public_path__ + "img/music.e1078793.png";